import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";

import "./assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/scss/argon-dashboard-react.scss";

import AdminLayout from "./layouts/Admin/Admin";
import AuthLayout from "./layouts/Auth/Auth";
import AuthContextProvider, { AuthContext } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import LoadingContextProvider from "./context/LoadingContext";
import CommitmentContextProvider from "./context/CommitmentContext";
import LeadContextProvider from "./context/LeadContext";
import GoogleCalendarContextProvider from "./context/GoogleCalendarContext";

// ✅ IMPORTA A PÁGINA
import PrivacyPolicy from "./views/PrivacyPolicy";

const rootElement =
  document.getElementById("root") ?? document.createElement("div");
const root = ReactDOM.createRoot(rootElement);

function CustomRoute() {
  const { authenticated, loadingButton, handleLogout } = useContext(AuthContext);
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  // ✅ Evita setInterval a cada render
  useEffect(() => {
    const id = window.setInterval(() => {
      handleLogout();
    }, 100 * 60 * 60 * 1000);

    return () => window.clearInterval(id);
  }, [handleLogout]);

  // ✅ Registra SW uma vez
  useEffect(() => {
    const configuration = {
      onUpdate: (registration: ServiceWorkerRegistration) => {
        if (registration && registration.waiting) {
          setShowUpdateModal(true);
        }
      },
    };

    serviceWorkerRegistration.register(configuration);
  }, []);

  const handleUpdateConfirmation = () => {
    localStorage.removeItem("token");
    sessionStorage.clear();

    document.cookie.split(";").forEach(function (cookie) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie =
        name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    });

    caches.keys().then(function (cacheNames) {
      cacheNames.forEach(function (cacheName) {
        caches.delete(cacheName);
      });
    });

    serviceWorkerRegistration.unregister();
    window.location.reload();
    handleLogout();
  };

  if (loadingButton) {
    return <div>Carregando...</div>;
  }

  return (
    <>
      <Routes>
        <Route path="/privacy" element={<PrivacyPolicy />} />

        <Route path="/auth/*" element={<AuthLayout />} />

        <Route
          path="/admin/*"
          element={authenticated ? <AdminLayout /> : <Navigate to="/auth/" replace />}
        />

        <Route
          path="/"
          element={<Navigate to={authenticated ? "/admin/" : "/auth/"} replace />}
        />
        <Route
          path="*"
          element={<Navigate to={authenticated ? "/admin/" : "/auth/"} replace />}
        />
      </Routes>

      <Modal isOpen={showUpdateModal}>
        <ModalBody>
          Uma nova versão do aplicativo está disponível. Deseja recarregar a
          página para aplicar as alterações?
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleUpdateConfirmation}>
            OK
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

root.render(
  <BrowserRouter>
    <ToastProvider>
      <LoadingContextProvider>
        <AuthContextProvider>
          <CommitmentContextProvider>
            <LeadContextProvider>
              <GoogleCalendarContextProvider>
                <CustomRoute />
              </GoogleCalendarContextProvider>
            </LeadContextProvider>
          </CommitmentContextProvider>
        </AuthContextProvider>
      </LoadingContextProvider>
    </ToastProvider>
  </BrowserRouter>
);